import { render, staticRenderFns } from "./ModalPreviewVideo.vue?vue&type=template&id=224382d5&"
import script from "./ModalPreviewVideo.vue?vue&type=script&lang=js&"
export * from "./ModalPreviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./ModalPreviewVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports